const CSRF_COOKIE = '_eid_csrf_v1'
const CSRF_HEADER = 'X-CSRF-Token'

export const getCsrfToken = (): string | undefined => {
    if (typeof document === 'undefined') return undefined
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${CSRF_COOKIE}=([^;]+)`))
    return match ? decodeURIComponent(match[1]) : undefined
}

export const csrfHeaders = (): Record<string, string> => {
    const token = getCsrfToken()
    return token ? { [CSRF_HEADER]: token } : {}
}
